import {
  Box, Card, CircularProgress, Typography,
} from '@mui/material';
import { useAppSelector } from '../../../app/hooks';
import { ReactComponent as Barcode } from '../../../assets/svg/thatBook/barCodeNoColor.svg';

const CardTotalCodes = () => {
  const { generalStatistics, loadingGeneralStatistic } = useAppSelector(( state ) => state.dashboard );
  const { codes } = generalStatistics;
  return (
    <Card sx={{ backgroundColor: '#F44336', color: 'white', height: '100%' }}>
      <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
        <Box minHeight={60}>
          <Typography variant="h6">
            {loadingGeneralStatistic ? <CircularProgress size={24} color="inherit" /> : (
              <>
                {codes.created}
              </>
            )}
          </Typography>
          <Typography variant="subtitle1">Códigos</Typography>
        </Box>
        <Barcode width={50} height={50} fill="white" />
      </Box>
    </Card>
  );
};

export default CardTotalCodes;
